import SMManagementOffers from "./SMManagementOffers";

const SMManagement = () => {
  return (
    <section className="solution-item-page">
      <SMManagementOffers />
    </section>
  ); 
};

export default SMManagement;
